<script lang="ts">
    import { Dialog, Modal, Tabs } from "attractions";
    import AddEmployee from "./AddEmployee.svelte";
    import ListEmployees from "./ListEmployees.svelte";

    export let open: boolean;

    const availableTabs = ["Wszyscy", "Nowy pracownik"];
    let selectedTab: string = availableTabs[0];
</script>

<Modal bind:open let:closeCallback>
    <Dialog title="Pracownicy" {closeCallback}>
        <Tabs
            class="modalTabs"
            name="menu"
            items={availableTabs}
            bind:value={selectedTab}
        />
        <section class="modalContent">
            {#if selectedTab == availableTabs[0]}
                <ListEmployees />
            {/if}
            {#if selectedTab == availableTabs[1]}
                <AddEmployee bind:open={open} />
            {/if}
        </section>
    </Dialog>
</Modal>